import { thirdPartyProviders as base } from '../base';
import { thirdPartyProviders as AT } from './AT';
import { thirdPartyProviders as CZ } from './CZ';
import { thirdPartyProviders as HU } from './HU';
import { thirdPartyProviders as RO } from './RO';
import { thirdPartyProviders as SK } from './SK';

export const featureConfigMap = {
    base,
    AT,
    CZ,
    HU,
    RO,
    SK,
};
